import { useTheme } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import DateSelect from "../Components/DateSelect";
import SortableTable from "../Components/SortableTable";
import { showPopupSnackbar } from "../redux/actions/snackbarActions";
import {
  formatTimeWithTZOffset,
  getTimestampWithoutOffset,
  getToken,
  validateDateType,
} from "../Utils/Common";
import EnvSettings from "../Utils/EnvSettings";
import { useStyles } from "../Utils/Styles";

const server = EnvSettings.server;

function formatTransportationData(data) {
  var arr = [];
  data.forEach((element) => {
    arr.push({
      id: element.id,
      startTime: formatTimeWithTZOffset(element.startTime),
      endTime: formatTimeWithTZOffset(element.endTime),
      description: element.description,
      serialNumber: element.Device.serialNumber,
      deviceName: element.Device.deviceName,
      alerts: element.Alerts.length,
    });
  });
  return arr;
}

export default function Transports(props) {
  const classes = useStyles();
  const theme = useTheme();
  //const [chartData, setChartData] = useState();
  const [recentTransports, setRecentTransports] = useState();
  const { t } = useTranslation();
  const today = formatTimeWithTZOffset(new Date().toISOString()).substr(0, 10);
  //const [oneDate, setOneDate] = useState(true);
  const [selectedDate, setDate] = useState();
  const [rangeStartTime, setRangeStartTime] = useState();
  const [rangeEndDate, setRangeEndDate] = useState();
  const [rangeEndTime, setRangeEndTime] = useState();
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();

  let setRowStyle = (data) => {
    if (data.alerts > 0) {
      return {
        backgroundColor: theme.palette.warning.light,
        cursor: "pointer",
      };
    }
    return { cursor: "pointer" };
  };

  let handleRowClick = (data) => {
    history.push("/transports/" + data);
  };

  useEffect(() => {
    const getTransports = () => {
      setLoading(true);
      var stime = undefined;
      var etime = undefined;
      if (
        validateDateType(selectedDate, "date") &&
        validateDateType(rangeStartTime, "time")
      ) {
        stime = getTimestampWithoutOffset(
          selectedDate + " " + rangeStartTime + ":00"
        );
      } else if (validateDateType(selectedDate, "date")) {
        stime = getTimestampWithoutOffset(selectedDate + " 00:00:00");
      }
      if (
        validateDateType(rangeEndDate, "date") &&
        validateDateType(rangeEndTime, "time")
      ) {
        etime = getTimestampWithoutOffset(
          rangeEndDate + " " + rangeEndTime + ":59"
        );
      } else if (validateDateType(rangeEndDate, "date")) {
        etime = getTimestampWithoutOffset(rangeEndDate + " 23:59:59");
      }

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: getToken(),
          limit: 500,
          time_period_start: stime,
          time_period_end: etime,
        }),
      };
      fetch(server + "/get_transportation_list", requestOptions)
        .then((res) => res.json())
        .then((result) => {
          if (process.env.NODE_ENV !== "production") {
            console.log(result);
          }
          if (result.error) {
            dispatch(showPopupSnackbar(result));
          } else {
            setRecentTransports(formatTransportationData(result.transports));
          }
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
        });
    };

    getTransports();
  }, [rangeEndTime, rangeEndDate, rangeStartTime, selectedDate, dispatch]);

  let handleDate = (e) => {
    if (validateDateType(e.target.value, "date")) {
      if (e.target.value !== today) {
        setDate(e.target.value);
      } else {
        setDate(today);
      }
    }
  };

  return (
    <Grid container spacing={3}>
      <DateSelect
        handleDate={handleDate}
        selectedDate={selectedDate}
        setDate={setDate}
        rangeStartTime={rangeStartTime}
        setRangeStartTime={setRangeStartTime}
        rangeEndDate={rangeEndDate}
        setRangeEndDate={setRangeEndDate}
        rangeEndTime={rangeEndTime}
        setRangeEndTime={setRangeEndTime}
        activityIndicator={loading}
      />
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          {recentTransports ? (
            <SortableTable
              data={{
                headCells: [
                  {
                    id: "startTime",
                    numeric: false,
                    disablePadding: false,
                    label: t("transportList.started"),
                  },
                  {
                    id: "endTime",
                    numeric: false,
                    disablePadding: false,
                    label: t("transportList.ended"),
                  },
                  {
                    id: "description",
                    numeric: false,
                    disablePadding: false,
                    label: t("transportList.description"),
                  },
                  {
                    id: "serialNumber",
                    numeric: false,
                    disablePadding: false,
                    label: t("transportList.serial"),
                  },
                  {
                    id: "deviceName",
                    numeric: false,
                    disablePadding: false,
                    label: t("transportList.name"),
                  },
                  {
                    id: "alerts",
                    numeric: false,
                    disablePadding: false,
                    label: t("transportList.alerts"),
                  },
                ],
                defaultSortRow: "startTime",
                handleRowClick: handleRowClick,
                getRowStyle: setRowStyle,
                tableData: recentTransports,
                rowsPerPage: 25,
              }}
            />
          ) : undefined}
          {/*<TransportList data={recentTransports}/> */}
        </Paper>
      </Grid>
    </Grid>
  );
}
